var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30360_4606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.36979 11.5524L4.08479 10.8424C3.3019 10.1394 2.68677 9.26971 2.28479 8.29736C3.29979 5.76236 6.09979 3.79736 8.74979 3.79736C9.43172 3.80655 10.1075 3.92818 10.7498 4.15736L11.5248 3.37736C10.6462 3.00578 9.70366 2.80878 8.74979 2.79736C7.12005 2.85865 5.54398 3.39614 4.21639 4.34341C2.8888 5.29067 1.86787 6.60619 1.27979 8.12736C1.24007 8.23722 1.24007 8.35751 1.27979 8.46736C1.72391 9.64587 2.44 10.7029 3.36979 11.5524Z",
    fill: "#67A3CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.16236C6.78477 7.68322 6.99084 7.2326 7.33054 6.8929C7.67024 6.55321 8.12086 6.34713 8.6 6.31236L9.505 5.40236C8.99788 5.26884 8.46462 5.27057 7.95838 5.40739C7.45214 5.54422 6.99061 5.81135 6.6198 6.18216C6.24899 6.55297 5.98185 7.0145 5.84503 7.52074C5.70821 8.02698 5.70647 8.56024 5.84 9.06736L6.75 8.16236ZM16.22 8.12736C15.6467 6.63397 14.649 5.34088 13.35 4.40736L15.75 2.00236L15.045 1.29736L1.75 14.5924L2.455 15.2974L5.005 12.7474C6.14203 13.4142 7.43205 13.7758 8.75 13.7974C10.3797 13.7361 11.9558 13.1986 13.2834 12.2513C14.611 11.3041 15.6319 9.98854 16.22 8.46736C16.2597 8.35751 16.2597 8.23722 16.22 8.12736ZM10.75 8.29736C10.7479 8.64741 10.6539 8.99078 10.4776 9.29315C10.3012 9.59551 10.0485 9.84628 9.7448 10.0204C9.44112 10.1945 9.09705 10.2859 8.747 10.2853C8.39694 10.2848 8.05315 10.1924 7.75 10.0174L10.47 7.29736C10.6498 7.60023 10.7463 7.94519 10.75 8.29736ZM8.75 12.7974C7.70103 12.779 6.67195 12.508 5.75 12.0074L7.02 10.7374C7.59767 11.1382 8.29777 11.3234 8.99807 11.2606C9.69836 11.1978 10.3544 10.8911 10.8515 10.3939C11.3487 9.89673 11.6555 9.24073 11.7182 8.54043C11.781 7.84013 11.5958 7.14003 11.195 6.56236L12.63 5.12736C13.7773 5.91486 14.6745 7.01507 15.215 8.29736C14.2 10.8324 11.4 12.7974 8.75 12.7974Z",
    fill: "#67A3CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30360_4606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75 0.297363)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ae3e00123f3eebd75bb1f5ca6667d4d8.svg";
export { ForwardRef as ReactComponent };